<div class="table-responsive" [class.overflow-hidden]="passOnLogService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': passOnLogService.data.allPassOnLogs.data.length < 2}">
                <th></th>
                <th (click)="orderBy('passOnLogNumber', $event)">ID#<span class="footable-sort-indicator"></span></th>
                <th *ngIf="passOnLogService.buildings.length > 1"
                    (click)="orderBy('building.name', $event)">Building<span class="footable-sort-indicator"></span></th>
                <th (click)="orderBy('subject', $event)">Subject<span class="footable-sort-indicator"></span></th>
                <th (click)="orderBy('announcement', $event)">Announcement<span class="footable-sort-indicator"></span></th>
                <th (click)="orderBy('startDate', $event)">Start Date<span class="footable-sort-indicator"></span></th>
                <th (click)="orderBy('endDate', $event)">End Date<span class="footable-sort-indicator"></span></th>
                <th>Status</th>
                <th (click)="orderBy('createdBy', $event)">Created By<span class="footable-sort-indicator"></span></th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc">
                    Created On <span class="footable-sort-indicator"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="passOnLogService.data.allPassOnLogs.data" let-index="index">
                <tr (click)="$event.showDropdown || toggleCheck(item)"
                    [ngClass]="{'footable-odd': (index % 2 === 0), 'unread' : !item.markAsRead || !item.markAsRead.enable}">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>{{item.passOnLogNumber}}</td>
                    <td *ngIf="passOnLogService.buildings.length > 1">{{item.buildingName}}</td>
                    <td>{{item.subject}}</td>
                    <td>
                        <div class="no-hint-overflow">{{item.announcement}}</div>
                    </td>
                    <td>{{item.startDate | mccDate}}</td>
                    <td>{{item.endDate | mccDate}}</td>
                    <td>
                        <span *ngIf="item.status === 'current'" class="label label-current">Current</span>
                        <span *ngIf="item.status === 'future'" class="label label-future">Future</span>
                        <span *ngIf="item.status === 'past'" class="label label-past">Past</span>
                    </td>
                    <td>{{item.createdBy.fullName}}</td>
                    <td>{{item.createdAt | mccDate:false:true}}</td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of passOnLogService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td><td>&nbsp;</td><td *ngIf="passOnLogService.buildings.length > 1"></td><td></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!passOnLogService.data.allPassOnLogs.total"
                          [isServiceUnavailable]="passOnLogService.showServiceUnavailable"
                          [isLoading]="passOnLogService.spinnerShow">
        You have no pass on logs listed on the system<br>
        <span *ngIf="passOnLogService.canEdit()">
            <a href="javascript://" (click)="passOnLogService.isPassOnLogModalShow = true" class="mtv-primary-color clickable-text">add a log</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-list/pass-on-log-list.component.html